import { render, staticRenderFns } from "./SpendingDetails.vue?vue&type=template&id=f5f068a8&scoped=true&"
import script from "./SpendingDetails.vue?vue&type=script&lang=js&"
export * from "./SpendingDetails.vue?vue&type=script&lang=js&"
import style0 from "./SpendingDetails.vue?vue&type=style&index=0&id=f5f068a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f068a8",
  null
  
)

export default component.exports